// extracted by mini-css-extract-plugin
module.exports = {"Cali":"TextGroupSectionD_Cali__26KFG","TextContainer":"TextGroupSectionD_TextContainer__khTXE","Curve":"TextGroupSectionD_Curve__3rglx"};